import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import TravelAgencyLanding from "./components/TravelAgencyLanding";
import DownloadPage from "./components/DownloadPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<TravelAgencyLanding />} />
          <Route path="/download" element={<DownloadPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
